import { useMemo } from 'react';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import { filterNormalizers, options } from '../../constants/filter';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import { createMixedFilter } from '../../../../shared/packages/filter';

const selectValues = (state) => {
  return Object.keys(filterNormalizers).map((key) => state[key]);
};

const valuesIsEqual = (prev, current) => {
  const hasChanges = prev.some((value, index) => value !== current[index]);
  return !hasChanges;
};

const getFilteredData = (data, value) => {
  const filter = createMixedFilter(value, options);
  return filter(data);
};

export const useFilterConfig = () => {
  const rawValue = useSearchParamsSelector(selectValues, valuesIsEqual);

  const { setParams } = useSearchParamsMethods();

  const value = useMemo(() => {
    return Object.entries(filterNormalizers).reduce(
      (result, [key, nornalizer], index) => {
        const val = nornalizer(rawValue[index]);
        if (val != null) {
          result[key] = val;
        }
        return result;
      },
      {}
    );
  }, [rawValue]);

  const onChange = (name, value) => {
    setParams({ [name]: value, [searchParamKeys.roomsTablePage]: 1 });
  };

  return { value, onChange, getFilteredData };
};
